import { AxiosError, isAxiosError } from 'axios'

import consoleMessage from 'shared/utils/helpers/consoleMessage'
import { httpClient } from 'shared/lib'

import { KeepWholesalesPayload } from './types'

export default function keepWholesalesService(payload: KeepWholesalesPayload, locationUuid: string) {
   let errMessage = ''
   return httpClient
      .post<Result>(`location/${locationUuid}/cooperation/actions`, payload)
      .then((res) => ({ status: res.status }))
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('USERS_AND_SUBSCRIPTION editUser service', errMessage, 'error')
         throw error
      })
}
